import { useContext } from "react";
import { AppContext } from "../App";
import { MdArrowForward, MdNotifications, MdOutlineShoppingBag, MdPerson, MdStorefront } from "react-icons/md";

function Tile({ icon, title, subtitle, onClick }) {
  return (
    <div
      className="card mShadow2 p-3"
      style={{
        borderRadius: '16px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '14px',
              background: 'rgba(0,0,0,0.05)'
            }}
          >
            {icon}
          </div>
          <div>
            <div className="font-bold">{title}</div>
            <div className="text-muted" style={{ fontSize: '13px' }}>{subtitle}</div>
          </div>
        </div>
        <MdArrowForward className="align-self-center" style={{ opacity: 0.7 }} />
      </div>
    </div>
  )
}

export default function HomeMenu(props) {

  const appContext = useContext(AppContext);

  return (
    <div className="container">

      <div className="row">
        <div className="col-6 mb-3">
          <Tile
            icon={<MdStorefront size={26} />}
            title="Browse Products"
            subtitle="Explore latest listings"
            onClick={() => appContext.navTo({ item: 'home' })}
          />
        </div>
        <div className="col-6 mb-3">
          <Tile
            icon={<MdOutlineShoppingBag size={26} />}
            title="My Orders"
            subtitle="Track your purchases"
            onClick={() => appContext.navTo({ item: 'my-orders' })}
          />
        </div>
        <div className="col-6 mb-3">
          <Tile
            icon={<MdNotifications size={26} />}
            title="Updates"
            subtitle="Order status & messages"
            onClick={() => appContext.navTo({ item: 'notifications' })}
          />
        </div>
        <div className="col-6 mb-3">
          <Tile
            icon={<MdPerson size={26} />}
            title="Account"
            subtitle="Profile & settings"
            onClick={() => appContext.navTo({ item: 'account' })}
          />
        </div>
      </div>

    </div>
  )
}
